export const colors = {
  black: '#000000',
  white: '#ffffff',
  grey: '#ebedf0',
  lightGray: '#eeeeee',
  transparentBlack: 'rgba(0,0,0,.25)',
  iconBlue: 'rgb(24, 144, 255)',
  iconLightBlue: 'rgb(230, 247, 255)',
};
